exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subsection-title[data-v-0c70ac46]{color:#303030;font-family:Lato,sans-serif;font-size:20px;font-weight:700;letter-spacing:0;line-height:28px}.subsection-subtitle[data-v-0c70ac46]{color:#8392a6;font-family:Open Sans,sans-serif;font-size:14px;letter-spacing:0;line-height:24px}", ""]);

// exports
